import { render, staticRenderFns } from "./GreenExpenseForm.vue?vue&type=template&id=5805ca0d&scoped=true&"
import script from "./GreenExpenseForm.vue?vue&type=script&lang=js&"
export * from "./GreenExpenseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5805ca0d",
  null
  
)

export default component.exports